import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { HERO_LINES, BRAND } from "../data/content";

const EASE = [0.22, 1, 0.36, 1];

export default function Hero() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });

  const yImage = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const scaleImage = useTransform(scrollYProgress, [0, 1], [1, 1.08]);

  return (
    <section
      id="top"
      ref={ref}
      data-testid="hero-section"
      className="relative pt-32 md:pt-40 pb-16 md:pb-28 shell overflow-hidden"
    >
      {/* Main grid */}
      <div className="mt-4 md:mt-6 grid grid-cols-12 gap-6 md:gap-10 items-stretch">
        {/* Left: Headline */}
        <div className="col-span-12 lg:col-span-8 flex flex-col">
          <h1
            data-testid="hero-headline"
            className="font-display font-light text-[13vw] leading-[0.9] tracking-[-0.03em] text-[color:var(--collab-ink)] md:text-[11vw] lg:text-[9.5vw]"
          >
            {HERO_LINES.map((line, i) => (
              <span key={i} className="mask-line">
                <motion.span
                  initial={{ y: "110%" }}
                  animate={{ y: "0%" }}
                  transition={{
                    duration: 1.15,
                    ease: EASE,
                    delay: 0.35 + i * 0.16,
                  }}
                >
                  {i === 1 ? (
                    <>
                      brand{" "}
                      <em className="italic font-medium text-[color:var(--collab-forest)]">
                        stories
                      </em>
                    </>
                  ) : (
                    line
                  )}
                </motion.span>
              </span>
            ))}
          </h1>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: EASE, delay: 1.15 }}
            className="mt-10 md:mt-14 max-w-3xl pretty font-display font-light text-[color:var(--collab-muted)] text-[1.8rem] md:text-[2.25rem] lg:text-[2.7rem] leading-[1.25] tracking-[-0.01em]"
          >
            through creativity, design, immersive experiences, and flawless
            execution.
          </motion.div>
        </div>

        {/* Right: Clipped image — height matches the text column */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.4, delay: 0.9 }}
          className="col-span-12 lg:col-span-4 relative"
        >
          <div className="relative w-full h-full min-h-[420px] overflow-hidden bg-[color:var(--collab-forest-deep)]">
            <motion.img
              src="https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/zw96kz6b_3K4A3286.webp"
              alt="Trophy reveal moment on a lit football pitch with golden confetti"
              style={{ y: yImage, scale: scaleImage }}
              className="absolute inset-0 w-full h-[112%] object-cover"
              data-testid="hero-image"
            />
            <div className="absolute inset-0 pointer-events-none ring-1 ring-[rgba(245,241,232,0.15)]" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
